import { transformError as sdkTransformError } from '@wix/sdk-runtime/transform-error';
import { renameKeysFromSDKRequestToRESTRequest, renameKeysFromRESTResponseToSDKResponse, } from '@wix/sdk-runtime/rename-all-nested-keys';
import * as ambassadorWixDataV2DataCollection from './data-v2-data-collection-collections.http';
export var CollectionType;
(function (CollectionType) {
    /** User-created collection. */
    CollectionType["NATIVE"] = "NATIVE";
    /** [Collection](https://support.wix.com/en/article/velo-working-with-wix-app-collections-and-code#what-are-wix-app-collections) created by a Wix app when it is installed. This type of collection can be modified dynamically by that app (for example, Wix Forms). */
    CollectionType["WIX_APP"] = "WIX_APP";
    /** Collection created by a Wix Blocks app. */
    CollectionType["BLOCKS_APP"] = "BLOCKS_APP";
    /** Collection located in externally connected storage. */
    CollectionType["EXTERNAL"] = "EXTERNAL";
})(CollectionType || (CollectionType = {}));
export var Direction;
(function (Direction) {
    Direction["ASC"] = "ASC";
    Direction["DESC"] = "DESC";
})(Direction || (Direction = {}));
export var DataOperation;
(function (DataOperation) {
    DataOperation["AGGREGATE"] = "AGGREGATE";
    DataOperation["BULK_INSERT"] = "BULK_INSERT";
    DataOperation["BULK_REMOVE"] = "BULK_REMOVE";
    DataOperation["BULK_SAVE"] = "BULK_SAVE";
    DataOperation["BULK_UPDATE"] = "BULK_UPDATE";
    DataOperation["COUNT"] = "COUNT";
    DataOperation["DISTINCT"] = "DISTINCT";
    DataOperation["FIND"] = "FIND";
    DataOperation["GET"] = "GET";
    DataOperation["INSERT"] = "INSERT";
    DataOperation["INSERT_REFERENCE"] = "INSERT_REFERENCE";
    DataOperation["IS_REFERENCED"] = "IS_REFERENCED";
    DataOperation["QUERY_REFERENCED"] = "QUERY_REFERENCED";
    DataOperation["REMOVE"] = "REMOVE";
    DataOperation["REMOVE_REFERENCE"] = "REMOVE_REFERENCE";
    DataOperation["REPLACE_REFERENCES"] = "REPLACE_REFERENCES";
    DataOperation["SAVE"] = "SAVE";
    DataOperation["TRUNCATE"] = "TRUNCATE";
    DataOperation["UPDATE"] = "UPDATE";
    DataOperation["PATCH"] = "PATCH";
    DataOperation["BULK_PATCH"] = "BULK_PATCH";
})(DataOperation || (DataOperation = {}));
export var CollectionOperation;
(function (CollectionOperation) {
    /** Supports updating this collection. */
    CollectionOperation["UPDATE"] = "UPDATE";
    /** Supports removing this collections. */
    CollectionOperation["REMOVE"] = "REMOVE";
})(CollectionOperation || (CollectionOperation = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    Type["TEXT"] = "TEXT";
    Type["NUMBER"] = "NUMBER";
    Type["DATE"] = "DATE";
    Type["DATETIME"] = "DATETIME";
    Type["IMAGE"] = "IMAGE";
    Type["BOOLEAN"] = "BOOLEAN";
    Type["DOCUMENT"] = "DOCUMENT";
    Type["URL"] = "URL";
    Type["RICH_TEXT"] = "RICH_TEXT";
    Type["VIDEO"] = "VIDEO";
    Type["ANY"] = "ANY";
    Type["ARRAY_STRING"] = "ARRAY_STRING";
    Type["ARRAY_DOCUMENT"] = "ARRAY_DOCUMENT";
    Type["AUDIO"] = "AUDIO";
    Type["TIME"] = "TIME";
    Type["LANGUAGE"] = "LANGUAGE";
    Type["RICH_CONTENT"] = "RICH_CONTENT";
    Type["MEDIA_GALLERY"] = "MEDIA_GALLERY";
    Type["ADDRESS"] = "ADDRESS";
    Type["PAGE_LINK"] = "PAGE_LINK";
    Type["REFERENCE"] = "REFERENCE";
    Type["MULTI_REFERENCE"] = "MULTI_REFERENCE";
    Type["OBJECT"] = "OBJECT";
    Type["ARRAY"] = "ARRAY";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    Type["LEGACY_TIME"] = "LEGACY_TIME";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    Type["LEGACY_BOOK"] = "LEGACY_BOOK";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    Type["LEGACY_EXTERNAL_URL"] = "LEGACY_EXTERNAL_URL";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    Type["LEGACY_BROKEN_REFERENCE"] = "LEGACY_BROKEN_REFERENCE";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    Type["LEGACY_IMAGE"] = "LEGACY_IMAGE";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    Type["LEGACY_COLOR"] = "LEGACY_COLOR";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    Type["LEGACY_EXTERNAL_VIDEO"] = "LEGACY_EXTERNAL_VIDEO";
})(Type || (Type = {}));
export var QueryOperator;
(function (QueryOperator) {
    QueryOperator["EQ"] = "EQ";
    QueryOperator["LT"] = "LT";
    QueryOperator["GT"] = "GT";
    QueryOperator["NE"] = "NE";
    QueryOperator["LTE"] = "LTE";
    QueryOperator["GTE"] = "GTE";
    QueryOperator["STARTS_WITH"] = "STARTS_WITH";
    QueryOperator["ENDS_WITH"] = "ENDS_WITH";
    QueryOperator["CONTAINS"] = "CONTAINS";
    QueryOperator["HAS_SOME"] = "HAS_SOME";
    QueryOperator["HAS_ALL"] = "HAS_ALL";
    QueryOperator["EXISTS"] = "EXISTS";
    QueryOperator["URLIZED"] = "URLIZED";
})(QueryOperator || (QueryOperator = {}));
export var FieldPluginType;
(function (FieldPluginType) {
    FieldPluginType["UNKNOWN"] = "UNKNOWN";
    /** CMS-related field attributes */
    FieldPluginType["CMS"] = "CMS";
})(FieldPluginType || (FieldPluginType = {}));
export var Role;
(function (Role) {
    /** Unknown. */
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Site administrator. */
    Role["ADMIN"] = "ADMIN";
    /** Signed-in user who added content to this collection. */
    Role["SITE_MEMBER_AUTHOR"] = "SITE_MEMBER_AUTHOR";
    /** Any signed-in user. */
    Role["SITE_MEMBER"] = "SITE_MEMBER";
    /** Any site visitor. */
    Role["ANYONE"] = "ANYONE";
})(Role || (Role = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN_PUBLISH_PLUGIN_STATUS"] = "UNKNOWN_PUBLISH_PLUGIN_STATUS";
    Status["PUBLISHED"] = "PUBLISHED";
    Status["DRAFT"] = "DRAFT";
})(Status || (Status = {}));
export var Format;
(function (Format) {
    Format["UNKNOWN_URLIZED_PLUGIN_FORMAT"] = "UNKNOWN_URLIZED_PLUGIN_FORMAT";
    Format["ORIGINAL"] = "ORIGINAL";
    Format["PLAIN"] = "PLAIN";
})(Format || (Format = {}));
export var PluginType;
(function (PluginType) {
    /** Unknown plugin type. */
    PluginType["UNKNOWN_PLUGIN_TYPE"] = "UNKNOWN_PLUGIN_TYPE";
    /** Allows items to be marked as either draft or published. For each item you can set a publishing time when the item will become visible to site visitors. */
    PluginType["PUBLISH"] = "PUBLISH";
    /** Ensures the collection can have one item at most. Can only be applied to a new collection. */
    PluginType["SINGLE_ITEM"] = "SINGLE_ITEM";
    /** Generates item URLs for collections used by dynamic pages. */
    PluginType["URLIZED"] = "URLIZED";
    /** Deprecated. Will be removed in the future. */
    PluginType["GRIDAPPLESS"] = "GRIDAPPLESS";
    /** Indicates that the collection is translatable. This allows you to manage translation for selected fields using [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual). */
    PluginType["MULTILINGUAL"] = "MULTILINGUAL";
    /** Indicates that collection is shared with current site */
    PluginType["SHARED"] = "SHARED";
    /** Indicates that page link fields are persisted and can be updated */
    PluginType["EDITABLE_PAGE_LINK"] = "EDITABLE_PAGE_LINK";
    /** CMS-specific collection properties */
    PluginType["CMS"] = "CMS";
})(PluginType || (PluginType = {}));
export var PagingMode;
(function (PagingMode) {
    /** Offset-based paging. */
    PagingMode["OFFSET"] = "OFFSET";
    /** Cursor-based paging. */
    PagingMode["CURSOR"] = "CURSOR";
})(PagingMode || (PagingMode = {}));
/**
 * Describes who can perform certain action.
 * Each level includes all levels below it (except UNDEFINED).
 */
export var AccessLevel;
(function (AccessLevel) {
    /** Not set */
    AccessLevel["UNDEFINED"] = "UNDEFINED";
    /** Any subject, including visitors */
    AccessLevel["ANYONE"] = "ANYONE";
    /** Any signed-in user (both site members and collaborators) */
    AccessLevel["SITE_MEMBER"] = "SITE_MEMBER";
    /** Any signed-in user, but site members only have access to own items */
    AccessLevel["SITE_MEMBER_AUTHOR"] = "SITE_MEMBER_AUTHOR";
    /** Site collaborator that has a role with CMS Access permission */
    AccessLevel["CMS_EDITOR"] = "CMS_EDITOR";
    /** CMS administrators and users or roles granted with special access */
    AccessLevel["PRIVILEGED"] = "PRIVILEGED";
})(AccessLevel || (AccessLevel = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
/**
 * Order determines how values are ordered in the index. This is important when
 * ordering and/or range querying by indexed fields.
 */
export var Order;
(function (Order) {
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order || (Order = {}));
export var IndexStatus;
(function (IndexStatus) {
    /** Place holder. Never returned by the service. */
    IndexStatus["UNKNOWN"] = "UNKNOWN";
    /** Index creation is in progress. */
    IndexStatus["BUILDING"] = "BUILDING";
    /** Index has been successfully created and can be used in queries. */
    IndexStatus["ACTIVE"] = "ACTIVE";
    /** Index is in the process of being dropped. */
    IndexStatus["DROPPING"] = "DROPPING";
    /** Index has been dropped successfully. */
    IndexStatus["DROPPED"] = "DROPPED";
    /** Index creation has failed. */
    IndexStatus["FAILED"] = "FAILED";
    /** Index contains incorrectly indexed data. */
    IndexStatus["INVALID"] = "INVALID";
})(IndexStatus || (IndexStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
/**
 * Creates a new data collection.
 *
 * The request body must include an ID, details for at least 1 field, and a permissions object. If any of these are missing, the collection isn't created.
 * @param collection - Collection details.
 * @public
 * @requiredField collection
 * @requiredField collection._id
 * @requiredField collection.fields.key
 * @requiredField collection.fields.type
 * @requiredField collection.permissions.insert
 * @requiredField collection.permissions.read
 * @requiredField collection.permissions.remove
 * @requiredField collection.permissions.update
 * @param options - Options for creating a data collection.
 * @permissionId WIX_DATA.CREATE_COLLECTION
 * @permissionScope Manage Data Collections
 * @permissionScopeId SCOPE.DC-DATA.DATA-COLLECTIONS-MANAGE
 * @applicableIdentity APP
 * @returns Details of collection created.
 */
export async function createDataCollection(collection) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        collection: collection,
    });
    const reqOpts = ambassadorWixDataV2DataCollection.createDataCollection(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data)?.collection;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { collection: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['collection']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves a data collection by ID.
 * @param dataCollectionId - ID of the collection to retrieve.
 * @public
 * @requiredField dataCollectionId
 * @param options - Options for retrieving a data collection.
 * @permissionId WIX_DATA.GET_COLLECTION
 * @permissionScope Manage Data Collections
 * @permissionScopeId SCOPE.DC-DATA.DATA-COLLECTIONS-MANAGE
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Details of the collection requested.
 */
export async function getDataCollection(dataCollectionId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        dataCollectionId: dataCollectionId,
        consistentRead: options?.consistentRead,
    });
    const reqOpts = ambassadorWixDataV2DataCollection.getDataCollection(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data)?.collection;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                dataCollectionId: '$[0]',
                consistentRead: '$[1].consistentRead',
            },
            singleArgumentUnchanged: false,
        }, ['dataCollectionId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves a list of all data collections associated with the site or project.
 *
 * By default, the list is ordered by ID in ascending order.
 * @public
 * @param options - Options for retrieving a list of data collections.
 * @permissionId WIX_DATA.LIST_COLLECTIONS
 * @permissionScope Manage Data Collections
 * @permissionScopeId SCOPE.DC-DATA.DATA-COLLECTIONS-MANAGE
 * @applicableIdentity APP
 */
export async function listDataCollections(options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        sort: options?.sort,
        paging: options?.paging,
        consistentRead: options?.consistentRead,
    });
    const reqOpts = ambassadorWixDataV2DataCollection.listDataCollections(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                sort: '$[0].sort',
                paging: '$[0].paging',
                consistentRead: '$[0].consistentRead',
            },
            singleArgumentUnchanged: false,
        }, ['options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Updates a data collection.
 *
 * A collection ID, revision number, permissions, and at least 1 field must be provided within `options.collection`.
 * If a collection with that ID exists, and if its current `revision` number matches the one provided, it is updated.
 * Otherwise, the request fails.
 *
 * When a collection is updated, its `_updatedDate` property is changed to the current date and its `revision` property is incremented.
 *
 * > **Note:**
 * > After a collection is updated, it only contains the properties included in the `updateDataCollection()` call. If the existing collection has properties with values and those properties
 * > aren't included in the updated collection details, their values are lost.
 * @param collection - Updated collection details. The existing collection is replaced with this version.
 * @public
 * @requiredField collection
 * @requiredField collection._id
 * @requiredField collection.fields.key
 * @requiredField collection.fields.type
 * @requiredField collection.permissions.insert
 * @requiredField collection.permissions.read
 * @requiredField collection.permissions.remove
 * @requiredField collection.permissions.update
 * @requiredField collection.revision
 * @param options - Options for updating a data collection.
 * @permissionId WIX_DATA.UPDATE_COLLECTION
 * @permissionScope Manage Data Collections
 * @permissionScopeId SCOPE.DC-DATA.DATA-COLLECTIONS-MANAGE
 * @applicableIdentity APP
 * @returns Updated collection details.
 */
export async function updateDataCollection(collection) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        collection: collection,
    });
    const reqOpts = ambassadorWixDataV2DataCollection.updateDataCollection(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data)?.collection;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { collection: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['collection']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Deletes a data collection.
 *
 * > **Note:**
 * > Once a collection is deleted, it can't be restored.
 * @param dataCollectionId - ID of the collection to delete.
 * @public
 * @requiredField dataCollectionId
 * @permissionId WIX_DATA.DELETE_COLLECTION
 * @permissionScope Manage Data Collections
 * @permissionScopeId SCOPE.DC-DATA.DATA-COLLECTIONS-MANAGE
 * @applicableIdentity APP
 */
export async function deleteDataCollection(dataCollectionId) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        dataCollectionId: dataCollectionId,
    });
    const reqOpts = ambassadorWixDataV2DataCollection.deleteDataCollection(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { dataCollectionId: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['dataCollectionId']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
//# sourceMappingURL=data-v2-data-collection-collections.universal.js.map